import * as React from 'react';
import Box from '@mui/material/Box';
import Card from '@mui/material/Card';
import CardActions from '@mui/material/CardActions';
import CardContent from '@mui/material/CardContent';
import Button from '@mui/material/Button';
import Typography from '@mui/material/Typography';
import { CircularProgress, Grid } from '@mui/material';

const bull = (
  <Box
    component="span"
    sx={{ display: 'inline-block', mx: '2px', transform: 'scale(0.8)' }}
  >
    •
  </Box>
);

export default function BasicCard(props) {
  return (
    <Card style={{ height: '123px', display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent: 'center' }} >
      <CardContent style={{ display: 'flex', flexDirection: 'column', alignItems: 'center' }}>
        <Typography variant="h6" component="div" style={{ color: '#07689f', fontWeight: 'bold' }}>
          {props.name}
        </Typography>
        {
           props.loading ? <CircularProgress size={28}/> : <>
              <Typography variant="h5" style={{ fontSize: '1.8rem' }} >{props.total}</Typography>

{
  props.connected &&
  <div style={{ display: 'flex', flexDirection: 'row' }}>
    <div style={{ marginRight: '12px', color: 'green', alignItems: 'baseline' }}>
      <span style={{ fontSize: '1rem' }}> {props.connected} : </span>
      <span style={{ fontSize: '1.1rem', fontWeight: '600' }}> {props.connectedCount}  </span>
    </div>
    <div style={{ color: 'red', alignItems: 'baseline' }}>
      <span style={{ fontSize: '1rem', color: 'red' }}> {props.disconnected} : </span>
      <span style={{ fontSize: '1.1rem', fontWeight: '600' }}> {props.disconnectedCount} </span>
    </div>
  </div>
}
           </> 
        }
        

      </CardContent>

    </Card>
  );
}
